import { COLORS } from 'helpers/globals'

const handleStyle = {
  position: 'absolute',
  marginLeft: -7,
  marginTop: -8,
  width: '4rem',
  height: '1.9rem',
  cursor: 'pointer',
  borderRadius: 5,
  border: `solid 1px ${COLORS.primary}`,
  backgroundColor: '#fff',
  lineHeight: '1.9rem',
  fontSize: '1.2rem',
  textAlign: 'center',
  color: 'black'
}

export { handleStyle } 

export default {
  container: {
    height: '35px'
  },
  rangeLabel: {
    lineHeight: '1.4rem',
    fontSize: '1.5rem',
    color: 'black',
    textAlign: 'center',
    '& span': { color: COLORS.secondary }
  },
  rangeValue: {
    fontSize: '1.2rem'
  },
  sliderContainer: {
    display: 'inline-block',
    width: '70%',
    margin: '0 1rem'
  },
  mobileSliderContainer: {
    display: 'inline-block',
    width: '86%',
    marginLeft: '5%',
    marginTop: '1rem',
    touchAction: 'none'
  },
  bottomRowButton: {
    fontSize: '1.8rem',
    marginLeft: '1.8rem',
    color: '#428bca',
    cursor: 'pointer',
    position: 'relative',
    bottom: 9
  }
}



// WEBPACK FOOTER //
// ./src/components/AngleOfViewContainer/RangeAngleOfViewDisplay/style.js